<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="submit_form()" id="new_stakeholder_form">
                <div class="row">
                    <div class="col-12 col-md-6 my-2">
                        <label for="user_id" v-text="$t('label.user_id')"></label>
                        <input  type="text"
                                id="user_id"
                                name="user_id"
                                class="form-control"
                                v-model="form_data.user_id">
                    </div>

                    <div class="col-12 col-md-6 my-2">
                        <label for="phone" v-text="$t('label.phone')"></label>
                        <input  type="text"
                                id="phone"
                                name="phone"
                                class="form-control"
                                v-model="form_data.phone">
                    </div>
                </div>
                <div class="mt-4 mb-2">
                    <button type="submit" class="btn btn-success" v-text="$t('btn.add')"></button>
                </div>
            </form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content.vue';
import $ from 'jquery';
import { stakeholdersService } from '@/common/api.service';

export default {
    components: {
        mainContent
    },
    data() {
        return {
            form_data: {},
        };
    },
    methods: {
        submit_form() {
            let form = $('#new_stakeholder_form');

            form.validate({
                rules: {
                    user_id: {
                        required: true,
                    },
                    phone: {
                        required: true,
                    },
                }
            });

            if (!form.valid()) {
                return;
            }

            let params = {
                user_id:    this.form_data.user_id,
                phone:      this.form_data.phone,
            };

            stakeholdersService.createFromUsers(params).then(response => {
                this.$router.push('/stakeholders');
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data);
                }

                this.showMsg(form, 'danger', response.data.message);
            });
        },
    },
}
</script>
